import React from 'react';
import { Image, Modal, Platform, Pressable, Text, View } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { ImageZoom } from '@likashefqet/react-native-image-zoom';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import type { StoredFile } from '@hexia/survey-client/core';
import useTranslation from '../../../hooks/translation-hook';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const SurveyImagePreview = ({ file, onClose }: { file?: StoredFile; onClose(): void }) => {
  const t = useTranslation();
  const insets = useSafeAreaInsets();
  return <Modal visible={!!file} animationType="fade" onRequestClose={onClose}>
    <GestureHandlerRootView style={{ flex: 1, backgroundColor: '#101820', paddingTop: insets.top, paddingBottom: insets.bottom }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', padding: 12, gap: 12 }}>
        <Text style={{ flex: 1, color: '#ffffff', fontSize: 16 }} numberOfLines={2}>{file?.name}</Text>
        <Pressable accessibilityRole="button" accessibilityLabel={t('close')} onPress={onClose} style={{ width: 48, height: 48, alignItems: 'center', justifyContent: 'center' }}>
          <FontAwesomeIcon icon={faXmark} size={24} color="#ffffff" />
        </Pressable>
      </View>
      {file && (Platform.OS === 'web'
        ? <Image source={{ uri: file.content }} accessibilityLabel={file.name} style={{ flex: 1, width: '100%' }} resizeMode="contain" />
        : <ImageZoom key={file.content} uri={file.content} accessibilityLabel={file.name} style={{ flex: 1, width: '100%' }} resizeMode="contain" minScale={1} maxScale={5} minPanPointers={1} />)}
    </GestureHandlerRootView>
  </Modal>;
};
